export default function registerSmartImageLoading(app, store) {
  const ignoredPathParts = ['/icons/', '/logo/']

  const shouldTrackImage = (src) => {
    if (!src || src.startsWith('data:') || src.startsWith('blob:')) return false

    try {
      const url = new URL(src, window.location.origin)
      return !ignoredPathParts.some((pathPart) => url.pathname.includes(pathPart))
    } catch (error) {
      return false
    }
  }

  const markLoaded = (src) => {
    if (!shouldTrackImage(src)) return
    store.dispatch('requestLoadedArticleImage', src)
  }

  const applyToImage = (img) => {
    const src = img.currentSrc || img.getAttribute('src')
    if (!shouldTrackImage(src)) return

    const isLoaded = Boolean(store.state.loadedArticleImages?.[src]) || (img.complete && img.naturalWidth > 0)
    const isExplicitPriority = img.getAttribute('loading') === 'eager' || img.getAttribute('fetchpriority') === 'high'
    const isPriority = isLoaded || isExplicitPriority

    img.setAttribute('loading', isPriority ? 'eager' : 'lazy')
    img.setAttribute('fetchpriority', isPriority ? 'high' : 'auto')

    if (img.complete && img.naturalWidth > 0) {
      markLoaded(src)
      return
    }

    img.addEventListener('load', () => markLoaded(img.currentSrc || img.getAttribute('src')), { once: true })
  }

  const applyInElement = (element) => {
    if (!element?.querySelectorAll) return

    requestAnimationFrame(() => {
      element.querySelectorAll('img').forEach(applyToImage)
    })
  }

  app.mixin({
    mounted() {
      applyInElement(this.$el)
    },
    updated() {
      applyInElement(this.$el)
    },
  })
}
